<template>
    <div class="container">
        <div class="row">
            <div class="col-md-12 mt-10">

                <div v-if="$slots.image">
                    <slot name="image"></slot>
                </div>

                <div v-if="$slots.title">
                    <h2 class="error-title text-center line-height-1 font-size-px-99">
                        <slot name="title"></slot>
                    </h2>
                </div>

                <div v-if="$slots.description">
                    <slot name="description"></slot>
                </div>

                <div v-if="$slots.actions">
                    <slot name="actions"></slot>
                </div>

            </div>
        </div>
    </div>
</template>

<script>
import './BaseError.scss';

export default {
    name: "BaseError",
}
</script>

